module.exports = __webpack_public_path__ + "media/images/expert-slide4-thumb-e51ec2c26c71416cb1f22ba26d8077a4b8f648ecef18690e6c26ced3bbc66a3d.jpg";